import { get } from "lodash";
import { GadmFeature } from "./types";
import { POLYGON_STYLE } from "./mapConfig";

// Convierte coordenadas GeoJSON [lng, lat] al formato { lat, lng } de Google Maps
const toLatLng = (coord: number[]) => ({ lat: coord[1], lng: coord[0] });

// Normaliza Polygon y MultiPolygon a un array uniforme de rings (number[][][])
const getCoordinateRings = (feature: GadmFeature): number[][][] => {
  const type = get(feature, "geometry.type");
  const coords = get(feature, "geometry.coordinates") as number[][][] | number[][][][];
  if (type === "MultiPolygon") {
    return (coords as number[][][][]).flatMap((poly) => poly);
  }
  return coords as number[][][];
};

export interface BuildOptions {
  map: google.maps.Map;
  features: GadmFeature[];
  onFeatureClick: (feature: GadmFeature) => void;
}

// Construye y monta los google.maps.Polygon en el mapa, devuelve la lista para poder limpiarlos
export const buildPolygons = ({ map, features, onFeatureClick }: BuildOptions): google.maps.Polygon[] =>
  features.flatMap((feature) =>
    getCoordinateRings(feature).map((ring) => {
      const polygon = new google.maps.Polygon({ paths: ring.map(toLatLng), ...POLYGON_STYLE, map });
      polygon.addListener("click", () => onFeatureClick(feature));
      return polygon;
    })
  );

// Elimina del mapa todos los polígonos de la lista
export const clearPolygons = (polygons: google.maps.Polygon[]) => {
  polygons.forEach((p) => p.setMap(null));
};
